import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatDialog } from '@angular/material';
import { TranslateService } from '@ngstack/translate';
import { SubsidiaryDashboardContractStudentEmptyComponent } from '../subsidiary-dashboard-contract-student-empty/subsidiary-dashboard-contract-student-empty.component';
import { ActivatedRoute } from '@angular/router';

import { SubsidiaryStudentService } from 'src/app/services/http/business/subsidiary/dashboard/subsidiary-student.service';
import { SubsidiaryContractService } from 'src/app/services/http/business/subsidiary/dashboard/subsidiary-contract.service';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { SubsidiaryDashboardImportStudentFilesComponent } from '../subsidiary-dashboard-import-student-files/subsidiary-dashboard-import-student-files.component';
import { IConfirm } from 'src/app/interfaces/confirm';
import { ConfirmComponent } from 'src/app/components/confirm/confirm.component';
import { RegistrationService } from 'src/app/services/http/business/registration/registration.service';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { IError } from 'src/app/interfaces/error.interface';

@Component({
  selector: 'app-subsidiary-dashboard-contract-students',
  templateUrl: './subsidiary-dashboard-contract-students.component.html',
  styleUrls: ['./subsidiary-dashboard-contract-students.component.css']
})
export class SubsidiaryDashboardContractStudentsComponent implements OnInit {
  filter: any;
  customer: any;
  disablePersonAdd: boolean;
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = [
    "FullName",
    "CustomerContractTitle",
    "Nationalcode",
    "placement",
    "Gender",
    "function"
  ];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  pageSize: number;
  pageIndex: number;
  queryParams: any;
  contract: any;

  param: any;
  errorList: IError[] = [];
  errObject: any;
  errors = new Array();

  constructor(
    private route: ActivatedRoute,
    private dialog: MatDialog,
    public translate: TranslateService,
    private snackBar: SnackBarService,
    private errorService: ErrorsService,
    public registrationService: RegistrationService,
    private subsidiaryStudentService: SubsidiaryStudentService,
    private subsidiaryContractService: SubsidiaryContractService,

  ) {
  }

  ngOnInit() {

    this.route.paramMap.subscribe(params => {
      this.filter = params["params"];
    });
    // this.getContractById();
    this.refresh();
    this.getCustomerContractPersonAddState();
  }
  getContractById() {
    this.subsidiaryContractService.getContract(this.filter).subscribe(
      res => {
        this.contract = res.DataList[0];
      }
    );
  }

  getCustomerContractPersonAddState() {
    this.subsidiaryContractService.getCustomerContractPersonAddState(this.filter.ContractId).subscribe(
      res => {
        this.disablePersonAdd = res;
      }
    );
  }

  getLevelName(LevelPrerequisiteHolding: any) {
    return LevelPrerequisiteHolding.filter(function (e) {
      return e.RelationTypeId == 3
    })[0].PackageName + ' - ' + LevelPrerequisiteHolding.filter(function (e) {
      return e.RelationTypeId == 3
    })[0].LevelName
  }

  refresh() {
    this.subsidiaryStudentService.getStudentsInContract(this.filter).subscribe(
      res => {

        this.paginator.pageSize = 10;
        this.paginator.length = res.Total;
        this.pageIndex = 0;
        this.paginator.length = res.Total;
        this.dataSource = new MatTableDataSource(res.DataList);
      }
    );
  }

  onFileChange(event) {

    var files = event.target.files;
    var file = files[0];
    if (files && file) {
      // contractFileXLS
      if (file.size <= 99999) {
        this.subsidiaryStudentService.contractFileXLS(file).subscribe(() => {

          this.refresh();
          this.snackBar.OpenSnackBar(
            'ثبت با موفقیت انجام شد',
            "ok",
            3000,
            SoundEnum.beep
          );
        },
          () => { });
        var reader = new FileReader();
        // reader.onload = this._handleReaderLoaded.bind(this);
        reader.readAsBinaryString(file);
      } else {
        this.snackBar.OpenSnackBar(
          this.translate.get("require.fileUpload", {
            size: "99999kb"
          }),
          "ok",
          5000,
          SoundEnum.beep
        );
      }
    }
  }

  // _handleReaderLoaded(key,readerEvt) {
  //   this.fileList[key].ImageData=btoa(readerEvt.target.result);
  // }

  paginatorEvent(event) {
    this.subsidiaryStudentService.getStudentsInContract(this.filter, event.pageIndex + 1, event.pageSize)
      .subscribe(res => {
        this.pageSize = event.pageSize;
        this.paginator.length = res.Total;
        this.pageIndex = event.pageIndex + 1;
        this.dataSource = new MatTableDataSource(res.DataList);
      });
  }

  importFile() {

    this.dialog
      .open(SubsidiaryDashboardImportStudentFilesComponent, {
        width: "300px",
        data: this.filter,
        disableClose: true
      })
      .afterClosed()
      .subscribe(() => {

        this.paginatorEvent({ pageSize: this.pageSize, pageIndex: this.pageIndex });
      });
  }

  addStudent() {

    this.dialog
      .open(SubsidiaryDashboardContractStudentEmptyComponent, {
        width: "950px",
        // height:"950px",
        data: this.filter,
        disableClose: true
      })
      .afterClosed()
      .subscribe(() => {
        this.paginatorEvent({ pageSize: this.pageSize, pageIndex: this.pageIndex });
      });
  }
  editStudent(params: any) {

    this.dialog.open(SubsidiaryDashboardContractStudentEmptyComponent, {
      width: "950px",
      data: params,
      disableClose: true
    })
      .afterClosed()
      .subscribe(() => {
        this.paginatorEvent({ pageSize: this.pageSize, pageIndex: this.pageIndex });
      });
  }


  delete(params: any) {
    const confirm: IConfirm = {
      accept: true,
      message: "آیا از حذف دانشجو از قرارداد اطمینان دارید؟",
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    this.dialog
      .open(ConfirmComponent, {
        width: "500px",
        data: confirm
      })
      .afterClosed()
      .subscribe(res => {
        if (res) {
          this.errors = new Array();
          var data = {
            NationalCode: params.Nationalcode,
            CustomerContractId: this.filter.ContractId
          }
          this.registrationService.removeAghRegistration(data).subscribe(() => {
            this.snackBar.OpenSnackBar(
              'دانشجو از قرارداد حذف گردید',
              "ok",
              5000,
              SoundEnum.beep
            );
            this.paginatorEvent({ pageSize: this.pageSize, pageIndex: this.pageIndex - 1 });
          }, err => {
            // this.errObject = this.errorService.getError(err);
            // this.param = this.errorService.objectError(this.errObject);
            // this.errors = this.errorService.returnError(err);
            this.errorList = this.errorService.getErrorList(err.error)
          })
        }
      });
  }

}
